import styled from 'styled-components';

import { colors } from 'global/colors';

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${colors.white};
  padding: 5px 10px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  position: relative;
`;

export const Title = styled.span`
  text-transform: uppercase;
  color: ${colors.lightGray2};
  font-size: 14px;
  font-weight: bold;
`;

export const Label = styled.label`
  font-size: 13px;
  color: ${colors.darkGray};
  margin: 0;
  font-weight: 600;
  display: flex;
  align-items: center;
  user-select: none;
`;

export const LabelContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
`;

export const AmountLabel = styled.span`
  color: ${colors.lightGray2};
  font-family: monospace;
`;

export const ClearButton = styled.div`
  font-size: 12px;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
  color: ${colors.darkGray};
  font-weight: bold;
`;

export const RatingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ClearRatingButton = styled.div`
  font-size: 12px;
  cursor: pointer;
  color: ${colors.darkGray};
  font-weight: bold;
`;

export const FilterSection = styled.div`
  margin-bottom: 5px;
`;

export const KeywordsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
